/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  MergeUnmatchedChainsMutationResponse,
  MergeUnmatchedChainsPathParams,
  MergeUnmatchedChains404,
} from '../types/MergeUnmatchedChains'

function getMergeUnmatchedChainsUrl({
  import_number,
}: {
  import_number: MergeUnmatchedChainsPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/merge-unmatched-chains/` as const,
  }
  return res
}

/**
 * @summary Dispatch the merge-unmatched-chains step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/merge-unmatched-chains/}
 */
export async function mergeUnmatchedChains(
  {
    import_number,
  }: { import_number: MergeUnmatchedChainsPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    MergeUnmatchedChainsMutationResponse,
    ResponseErrorConfig<MergeUnmatchedChains404>,
    unknown
  >({
    method: 'POST',
    url: getMergeUnmatchedChainsUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
